import styled, { keyframes } from "styled-components";

import { CloseButton } from "ds/Button";
import * as Dropdown from "ds/Dropdown";
import SearchDefault from "ds/Search";
import { semiBoldAlias } from "Libs/theme";

const fullExpandWidth = "176px";
const minExpandWidth = "68px";
const expandOut = keyframes`
  0% {
    width: ${minExpandWidth};
  }
  100% {
    width: ${fullExpandWidth};
  }
`;

const expandIn = keyframes`
  0% {
    width: ${fullExpandWidth};
  }
  100% {
    width: ${minExpandWidth};
  }
`;

export const CloseWindow = styled(CloseButton)`
  float: right;
  margin-top: -4px;
  margin-right: -4px;
`;

export const Search = styled(SearchDefault)`
  margin-right: 8px;
`;

export const IconFilterWrapper = styled.span`
  margin-top: 2px;
  color: var(--section-slate-color, var(--slate));
  &:hover {
    color: var(--section-color-primary-600-color, var(--color-primary-600));
  }
`;

export const IconFilterWrapperContainer = styled.div`
  margin-right: 5px;
  margin-left: 5px;
`;

export const Wrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-bottom: 20px;
  width: auto;
  margin-bottom: 0;
  .info-dialog {
    margin-top: -5px;
  }
`;

export const FilterDropdownLabel = styled(Dropdown.Label)`
  ${Wrapper} > & {
    font-size: 13px;
    color: var(--section-granite-color, var(--granite));
    ${semiBoldAlias()};
    &.title {
      line-height: 24px;
      color: green;
    }

    .checkbox-field,
    .checkbox-field label {
      margin: 0;
    }
    .checkbox-field {
      margin-bottom: 8px;
      &.checked {
        label {
          color: var(
            --section-color-primary-600-color,
            var(--color-primary-600)
          );
        }
      }
    }
    .radio-field {
      &.checked {
        label {
          color: var(
            --section-color-primary-600-color,
            var(--color-primary-600)
          );
        }
      }
    }
    .search-wrapper {
      height: inherit;
      margin-right: 8px;
      display: none;
      input.search {
        width: 86px;
        animation: ${expandIn} 0.18s linear 1;
        padding: 0 8px 0 32px;
        &.active {
          width: ${fullExpandWidth};
          animation: ${expandOut} 0.18s linear 1;
        }
      }
    }
    .environments-filter-window {
      width: 300px;
      right: 50%;
      margin-right: -143px;

      h6 {
        font-size: 14px;
        color: var(--section-ebony-light-color, var(--ebony-light));
        ${semiBoldAlias()};
        &.title {
          font-weight: bold;
          line-height: 24px;
        }
      }

      .radio-field:last-child label,
      .radio-field:last-child {
        margin-bottom: 0;
      }
    }
    .info-button {
      > button {
        padding: 0 4px !important;
        border: none;
        width: auto;
        margin-right: 16px;
        @media (min-width: 1280px) {
          width: 70px;
        }
        &:hover,
        &.open {
          svg {
            transform: none;
            rect {
              fill: var(
                --icon-color-primary-600-fill,
                var(--color-primary-600)
              );
            }
          }
        }
      }
      .text {
        display: none;
        @media (min-width: 1280px) {
          display: inline-block;
        }
      }
    }
    @media (min-width: 580px) {
      .search-wrapper {
        display: inline-block;
      }
    }
    @media (min-width: 900px) and (max-width: 1000px) {
      width: 50%;
      .checkbox-field {
        margin-bottom: 8px;
      }
    }

    #radix-2 {
      padding-top: 2px;
      > ${IconFilterWrapper} {
        padding: 0 4px !important;
        border: none;
        width: auto;
        margin-right: 16px;

        @media (min-width: 1280px) {
          width: 70px;
        }
      }
      .text {
        display: none;
        @media (min-width: 1280px) {
          display: inline-block;
        }
      }
    }
    @media (min-width: 580px) {
      .search-wrapper {
        display: inline-block;
      }
    }
    @media (min-width: 900px) and (max-width: 1000px) {
      width: 50%;
      .checkbox-field {
        margin-bottom: 8px;
      }
    }
  }
`;

export const SearchByDropdownLabel = styled(Dropdown.Label)`
  display: flex;
  align-items: center;
  padding: 8px 16px 14px;
  ${Wrapper} > & {
    font-size: 13px;

    color: var(--section-granite-color, var(--granite));
    ${semiBoldAlias()};
    &.title {
      line-height: 24px;
      color: green;
    }

    .checkbox-field,
    .checkbox-field label {
      margin: 0;
    }
    .checkbox-field {
      margin-bottom: 8px;
      &.checked {
        label {
          color: var(
            --section-color-primary-600-color,
            var(--color-primary-600)
          );
        }
      }
    }
    .radio-field {
      &.checked {
        label {
          color: var(
            --section-color-primary-600-color,
            var(--color-primary-600)
          );
        }
      }
    }
    .search-wrapper {
      height: inherit;
      margin-right: 8px;
      display: none;
      input.search {
        width: 86px;
        animation: ${expandIn} 0.18s linear 1;
        padding: 0 8px 0 32px;
        &.active {
          width: ${fullExpandWidth};
          animation: ${expandOut} 0.18s linear 1;
        }
      }
    }
    .environments-filter-window {
      width: 300px;
      right: 50%;
      margin-right: -143px;

      h6 {
        font-size: 14px;
        color: var(--section-ebony-light-color, var(--ebony-light));
        ${semiBoldAlias()};
        &.title {
          font-weight: bold;
          line-height: 24px;
        }
      }

      .radio-field:last-child label,
      .radio-field:last-child {
        margin-bottom: 0;
      }
    }
    .info-button {
      > button {
        padding: 0 4px !important;
        border: none;
        width: auto;
        margin-right: 16px;
        @media (min-width: 1280px) {
          width: 70px;
        }
        &:hover,
        &.open {
          svg {
            transform: none;
            rect {
              fill: var(
                --icon-color-primary-600-fill,
                var(--color-primary-600)
              );
            }
          }
        }
      }
      .text {
        display: none;
        @media (min-width: 1280px) {
          display: inline-block;
        }
      }
    }
    @media (min-width: 580px) {
      .search-wrapper {
        display: inline-block;
      }
    }
    @media (min-width: 900px) and (max-width: 1000px) {
      width: 50%;
      .checkbox-field {
        margin-bottom: 8px;
      }
    }

    #radix-2 {
      padding-top: 2px;
      > ${IconFilterWrapper} {
        padding: 0 4px !important;
        border: none;
        width: auto;
        margin-right: 16px;

        @media (min-width: 1280px) {
          width: 70px;
        }
      }
      .text {
        display: none;
        @media (min-width: 1280px) {
          display: inline-block;
        }
      }
    }
    @media (min-width: 580px) {
      .search-wrapper {
        display: inline-block;
      }
    }
    @media (min-width: 900px) and (max-width: 1000px) {
      width: 50%;
      .checkbox-field {
        margin-bottom: 8px;
      }
    }
  }
`;

export const FragmentLabel = styled.h6<{ isMainLabel?: boolean }>`
  font-size: 14px;
  margin: 0px;

  & > ${FilterDropdownLabel} {
    margin-bottom: 8px;
    color: var(--section-granite-color, var(--granite));
    ${semiBoldAlias()};

    ${({ isMainLabel }) =>
      isMainLabel &&
      `
        padding-top: 8px;
        padding-bottom: 0;
        font-weight: 600;
        line-height: 24px;
    `}
  }
`;

export const RadioItem = styled(Dropdown.RadioItem)`
  label {
    font-weight: 400;
  }
`;

export const ToggleWrapper = styled.div`
  display: flex;
  margin-left: 8px;
  gap: 4px;
`;
